import React from "react";
import styles from "./styles.module.css";
import SummaryCell from "~components/WatchlistSummaryOverview/SummaryCell";
import {
  formatMoneyWithLeadingPlusOrMinus,
  formatWithCurrencyCommasAndDecimals,
} from "~utils/portfolio/formatNumber";
import type { WatchlistDashboardProps } from "~types/portfolio";

export default function SummaryOverview(props: WatchlistDashboardProps) {
  const { marketValue } = props;
  const { currentValue, todayGainLoss, totalGainLoss, cost, currency } =
    marketValue;

  return (
    <div className={styles.summaryOverview}>
      <div className={styles.summaryRowChange}>
        <SummaryCell
          title="Total Gain / Loss"
          value={totalGainLoss}
          currency={currency}
          formatter={formatMoneyWithLeadingPlusOrMinus}
          variant={"with-change"}
        />
        <SummaryCell
          title="Day Gain / Loss"
          value={todayGainLoss}
          formatter={formatMoneyWithLeadingPlusOrMinus}
          variant={"with-change"}
        />
      </div>
      <div className={styles.summaryRow}>
        <SummaryCell
          title="Value"
          value={currentValue}
          formatter={formatWithCurrencyCommasAndDecimals}
        />
        <SummaryCell
          title="Cost"
          value={cost}
          formatter={formatWithCurrencyCommasAndDecimals}
        />
      </div>
    </div>
  );
}
